// @ts-ignore
import { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AliveScope } from 'react-activation'
import { App, ConfigProvider } from 'antd'
import '@/locales'
import zhCN from 'antd/es/locale/zh_CN'
import enUS from 'antd/es/locale/en_US'
import 'dayjs/locale/zh-cn'
import './styles/index.less'
import Routes from '@/routes'
import '@/components/primeModal/animation.less'
import '@/views/micro/index'
import useTheme from '@/hooks/useTheme'
const microData = (window as any).microApp?.getData() || {}
// import '@/utils/opentelemetry'

// ======================================== React 18以上版本, 引入 <React.StrictMode />时，useEffect(()>{}, [])会触发两次,暂时移除StrictMode模式   ========================================
function RootApp() {
  const locale = microData.locale || 'zh'
  const { token, theme } = useTheme()
  const rootDom = document.getElementById('ikg-root')

  // 将 CSS 变量设置到 html 元素上
  useEffect(() => {
    const { colorPrimary, loginPageBgcolor } = theme
    if (colorPrimary) {
      document.documentElement.style.setProperty('--color-primary', colorPrimary)
    }
    if (loginPageBgcolor) {
      const [bgColor1, bgColor2, bgColor3] = loginPageBgcolor.split(' ')
      document.documentElement.style.setProperty('--bg-color1', bgColor1)
      document.documentElement.style.setProperty('--bg-color2', bgColor2)
      document.documentElement.style.setProperty('--bg-color3', bgColor3)
    }
  }, [theme])

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={locale === 'en' ? enUS : zhCN}
        theme={{ token }}
        prefixCls="ikg"
        getPopupContainer={() => rootDom as any}
      >
        <AliveScope>
          <Suspense fallback={<div>Loading...</div>}>
            <App>
              <Routes />
            </App>
          </Suspense>
        </AliveScope>
      </ConfigProvider>
    </BrowserRouter>
  )
}

let root: any = null
const render = () => {
  const rootDom = document.getElementById('ikg-root')
  root = ReactDOM.createRoot(rootDom as any)
  root.render(
    <RootApp />
  )
}

const _window = window as any

// 如果不在微前端环境，则直接执行render渲染
if (!_window.__MICRO_APP_ENVIRONMENT__) {
  render()
} else {
  _window.mount = () => {
    render()
  }
  _window.unmount = () => {
    root.unmount()
  }
}
